import { UserInfoResponse } from 'modules/user/api/types'
import { atom } from 'recoil'

export const selectedUserInfoState = atom<UserInfoResponse | undefined>({
  key: 'selectedUserInfoState',
  default: undefined,
})
